const { setTimeout } = require("core-js");

const refinementsButton = document.querySelector('.filter-button button');
const refinementsTitle = document.querySelector('.modal-filters-order .title-wrapper');
const interceptTrigger1 = document.querySelector('.search-no-result-decorator-container .plp-banner');
const interceptTrigger2 = document.querySelector('.search-no-result-decorator-container .intersect-trigger-grid-bottom');
let interceptCardTrigger = document.querySelectorAll('.product-grid .mm-product-card');
const activeFilters = document.querySelector('.active-filters');
let scrollPos;
const isSearchPage = !document.querySelector('.search-no-result-decorator-container.plp-case');

// console.log('search-result-page');

/**
 *
 * @param {*} el is the target element
 * @param {*} act is the action (add or remove)
 * @param {*} cls is the class that has to be added or removed
 * @returns add or remove class event
 */
const addRemoveClass = (el, act, cls) => {
  if(el && act && cls) {
   cls.split(' ').forEach(c => act === 'add' ? el.classList.add(c) : el.classList.remove(c))
  }
};

addRemoveClass(document.querySelector('.search-no-result-decorator-container'), isSearchPage ? 'add' : 'remove', 'search-page');


function appliedFiltersButtonDot() {
  let filterCount = 0;
  let isAlmostOneFilterSelected = false;
  activeFilters.innerHTML = "";
  document.querySelectorAll('.modal-content .filters-input-global-wrapper input').forEach(r => {
    if(r.getAttribute('checked') !== null) {
      var linked_title = r.dataset.link;
      if (linked_title != null && linked_title != '') {
        document.querySelectorAll('.js-accordion-trigger.' + linked_title)[0].classList.add('-dot-info');
        filterCount++;
        var div = '<button class="mm-button filter-selected">' + r.nextSibling.parentNode.innerText + " <i class='mm-icon'><svg role='presentation' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' class='icon ' aria-hidden='true'><use href='#close'></use></svg></i></button>";
        activeFilters.innerHTML += div;
      }
      isAlmostOneFilterSelected = true;
    }
  });
  addRemoveClass(refinementsButton, isAlmostOneFilterSelected ? 'add' : 'remove', '-dot-info');

  document.documentElement.style.setProperty('--content-filters', '"' + filterCount.toString() + '"');
  if (filterCount > 0) {
    document.querySelectorAll('.number-results')[0].classList.remove('hidden');
    addRemoveClass(refinementsTitle, 'add', '-dot-info');
  } else {
    document.querySelectorAll('.number-results')[0].classList.add('hidden');
    addRemoveClass(refinementsTitle, 'remove', '-dot-info');
  }
}

let options = {
  root: document,
  rootMargin: '0px 0px 0px 0px',
  threshold: 0,
}

let cardOptions = {
  root: document,
  rootMargin: '0px 0px 0px 0px',
  threshold: 1,
}

let productCardElement = document.querySelectorAll('.product-grid-container .mm-product-card');

observer = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if(entry.target.classList.contains('plp-banner')) {
      if (entry.intersectionRatio <= 0 && entry.boundingClientRect.top <= 0) {
        addRemoveClass(refinementsButton, 'add', 'floating-position -rounded shadow-md -xl');
      } else if(entry.intersectionRatio > 0 && interceptTrigger1.getBoundingClientRect().bottom > 0) {
        addRemoveClass(refinementsButton, 'remove', 'floating-position -rounded shadow-md -xl');
      }
    } else if(entry.target.classList.contains('intersect-trigger-grid-bottom')) {
      if (entry.intersectionRatio <= 0 && entry.boundingClientRect.top <= 0) {
        addRemoveClass(refinementsButton, 'remove', 'floating-position -rounded shadow-md -xl');
      } else if(entry.intersectionRatio > 0 && interceptTrigger2.getBoundingClientRect().bottom > 0) {
        addRemoveClass(refinementsButton, 'add', 'floating-position -rounded shadow-md -xl');
      }
    }
  });
}, options);

cardObserver = new IntersectionObserver((entries) => {
  // entries.forEach(entry => addRemoveClass(entry.target, entry.isIntersecting ? 'add' : 'remove', '-inview')
  entries.forEach(entry => entry.isIntersecting ? addRemoveClass(entry.target, 'add', '-inview') : null
)}, cardOptions);

interceptTrigger1 && observer.observe(interceptTrigger1);
interceptTrigger2 && observer.observe(interceptTrigger2);

interceptCardTrigger.forEach(card => cardObserver.observe(card));

$('body').on('product:update-plp-cards', function() {
  interceptCardTrigger = document.querySelectorAll('.product-grid .mm-product-card');
  interceptCardTrigger.forEach(card => {
    cardObserver.unobserve(card);
    cardObserver.observe(card);
  });
  appliedFiltersButtonDot();
  mobileTouchBehavior();
});

$('body').on('click', '.single-element-content-image', function(e) {
   if(e.target.closest('.vjs-button')){
     e.preventDefault();
   }
})

$('body').on('click', '.filter-selected', function(e) {
  var target = e.currentTarget.innerText;
  document.getElementById('filter-' + target).click();
})

appliedFiltersButtonDot();


const modalButton = document.querySelector('.modal-header button');
modalButton ? modalButton.addEventListener('click', () => document.querySelector('body').style.overflow = 'auto') : null;


//////////////////////// Mobile Touch Behavior ////////////////////////
let mobileTouchHasMoved;
let hoveredElement;
const removeHoverOnNextScroll = () => {
  if( hoveredElement ){
    hoveredElement.classList.remove('hover');
    document.activeElement.blur();
    window.removeEventListener('scroll', removeHoverOnNextScroll);
  }
};

function handleTouchStart(evt) {
  scrollPos = window.scrollY;
  hoveredElement && hoveredElement.classList.remove('hover');
  mobileTouchTimeOut = setTimeout(function() {
    if (!mobileTouchHasMoved) {
      hoveredElement = evt.target.querySelector('.single-element-content-image');
      hoveredElement.classList.add('hover');
      window.addEventListener('scroll', removeHoverOnNextScroll);
    }
  }, 250);
}

function handleTouchMove() {
  mobileTouchHasMoved = true;
  clearTimeout(mobileTouchTimeOut);
}

function handleTouchEnd(evt) {
  const anchorLink = evt.target.querySelector('a');
  if (anchorLink){
    if (!mobileTouchHasMoved && evt.type === 'touchend') {
      anchorLink.click();
    }
  }
  mobileTouchHasMoved = false;
}

function mobileTouchBehavior() {
  var elements = document.querySelectorAll(".search-no-result-decorator-container .search-result .product-grid .product-tile");
  elements.forEach( el => {
    el.addEventListener("touchstart", handleTouchStart);
    el.addEventListener("touchmove", handleTouchMove);
    el.addEventListener("touchend", handleTouchEnd);
    el.addEventListener("touchcancel", handleTouchEnd);
  });
}

if(window.innerWidth < 1024){
  mobileTouchBehavior();
}

function isMixedSearch() {
  const mmCards = document.querySelector('.product-grid-container .mm-product-card.-brand-mm');
  const mm6Cards = document.querySelector('.product-grid-container .mm-product-card.-brand-mm6');
  const searchResultContainer = document.querySelector('.search-no-result-decorator-container');
  if(mmCards && mm6Cards) {
    searchResultContainer ? searchResultContainer.classList.add('mixed-brand-search') : null;
  } else {
    searchResultContainer ? searchResultContainer.classList.remove('mixed-brand-search') : null;
  }
}

isMixedSearch();

function updateCountrySelector() {
  const cgid = document.querySelector('.category-id');
  if (cgid && cgid.getAttribute('value')) {
    const countrySelectorHeader = document.querySelector('.country-selector-header');
    const countrySelectorFooter = document.querySelector('.country-selector-footer');
    countrySelectorHeader.setAttribute('href', countrySelectorHeader.getAttribute('href') + '?cgid=' + cgid.getAttribute('value'));
    countrySelectorFooter.setAttribute('href', countrySelectorFooter.getAttribute('href') + '?cgid=' + cgid.getAttribute('value'));
  }
}

updateCountrySelector();

function updateCardsHeight() {
let height = $('.grid-product .mm-product-card__hero')[0].clientHeight.toString() + 'px';
let mobileCardHeight = $('.js_search-results .product-grid .mm-product-card')[0].clientHeight.toString() + 'px';
document.documentElement.style.setProperty('--cards-height', height);
document.documentElement.style.setProperty('--mobile-cards-height', mobileCardHeight);
}

updateCardsHeight();

window.addEventListener('resize', () => {
  updateCardsHeight();
});
